import React, {Component, useContext, useEffect, useState} from 'react';
import ReactDOM from 'react-dom';
import { Button, ButtonCancel, ButtonModify, ButtonProceed, ButtonReturn } from '../../../../components/buttons';
import { Layout, MinMaxLayout, SeventyThirtyLayout, SixtyFourtyLayout } from '../../../../layouts';
import Welcome from '../../../../layouts/welcome';
import Row from '../../../../components/row';
import Container from '../../../../layouts/containers/container';
import List from '../../../../components/list';
import ContainerTable from '../../../../layouts/containers/container-table';
import InputsCheckbox from '../../../../components/inputs/inputs-checkbox';
import LabelContainer from '../../../../components/label-container';
import Blurred from '../../../../components/blurred';
import InputsCounter from '../../../../components/inputs/inputs-counter';
import DateTimeInput from '../../../../components/inputs/date-time-input';
import ErrorContainer from '../../../../components/error-container';
import InputsText from '../../../../components/inputs/inputs-text';
import _ from 'lodash';
import PopupsAdditionalPackageDetails from '../../../bookings/popups/popups-additional-package-details';
import PopupContext from '../../../../context/context-popup';
import PopupsAttendees from '../../popups/popups-attendees-manual';
import eventsApi from '../../../../lib/events/events-api';
import queryString from 'query-string';
import { getDSTLocalTime } from '../../../../lib/helpers/datetime-helpers';
import companiesApi from '../../../../lib/companies/companies-api';
import MediaHelper from '../../../../lib/helpers/media';
import BillingDetails from '../../../../components/billing-profile';

const YourDetails = () => {
    const [ company, setCompany ] = useState(null);

    useEffect(() => {
        companiesApi.getCompany(window.user.company_id).then(({ data }) => {
            setCompany(data);
        });
    }, []);

    const Item = ({ title, value }) => {
        return (
            <List gap='10px' style={{ flex: '1 0 0' }}>
                <Container.Title style={{ whiteSpace: 'nowrap' }} color="#929BA8">{ title }</Container.Title>
                <Container.Text fontSize="16px">{ value }</Container.Text>
            </List>
        )
    }

    const Flex = ({ direction, children }) => {
        return (
            <div style={{
                display: 'flex',
                flexDirection: direction,
                gap: '20px',
            }}>
                { children }
            </div>
        )
    }

    const profile = company?.billing_profile;

    return (
        <Container>
            <Container.Header>
                <Container.Text color="#FF6933" fontSize="18px">Your Billing Details</Container.Text>
            </Container.Header>

            <Container.Content>
                <Flex direction="column">
                    <Flex direction="row">
                        <Item title="First Name" value={profile?.first_name}/>
                        <Item title="Last Name" value={profile?.last_name}/>
                    </Flex>
                    <Flex direction="row">
                        <Item title="Company" value={profile?.company_name}/>
                    </Flex>
                    <Item title="Email Address" value={profile?.email_address}/>
                    <Flex direction="row">
                        <Item title="Telephone Number" value={profile?.tel_no}/>
                        <Item title="SAP Number" value={profile?.sap_number}/>
                    </Flex>
                </Flex>
            </Container.Content>
        </Container>
    )
}

const Summary = ({
    quote,
}) => {
    const data = []

    if (quote !== null) {
        quote?.tickets?.forEach(ticket => {
            data.push([
                ticket?.quantity,
                ticket?.name,
                `£${ticket?.total}`
            ])
        })
    }

    return (
        <ContainerTable
            showMobileColumns
            headerColor="rgb(146, 155, 168)"
            valueColor="black"
            className="table-bookings"
            columns={[
                { field: 'QTY', width: '25%' },
                { field: 'Item', width: '50%' },
                { field: 'Price/Credit(s)', width: '25%' },
            ]}
            data={[
                ...data
            ]}
        />
    )
}

const Ticket = ({
    index,
    error,
    ticket,
    onTicketQuantityChange
}) => {
    return (
        <ErrorContainer errors={error}>
            <Row gap="20px" justifyContent="space-between" className="booking-view__ticket">
                <LabelContainer label={<Container.Text fontSize="16px" color="black" className="ticket__name">{ ticket?.name }</Container.Text>}>
                    <Container.Text fontSize="14px">£{ticket?.price || 0}</Container.Text>
                </LabelContainer>

                <List gap="10px">
                    <Blurred toggled={ticket?.no_tickets_remaining === 0}>
                        <InputsCounter
                            value={ticket?.quantity}
                            onChange={e => onTicketQuantityChange(ticket?.id, e)}
                            max={ticket?.quantity_available}
                        />
                    </Blurred>
                </List>
            </Row>
        </ErrorContainer>
    )
}

const Tickets = ({
    tickets,
    howManyTicketsLeftMapped,
    onTicketQuantityChange,
    attendees,
    onAttendeeAdd,
    onAttendeeDelete,
    onAttendeeUpdate,
    getTicketError
}) => {
    const { setPopup } = useContext(PopupContext);

    const showAttendees = () => {
        setPopup(<PopupsAttendees attendees={attendees} onAttendeeAdd={onAttendeeAdd} onAttendeeDelete={onAttendeeDelete} onAttendeeUpdate={onAttendeeUpdate} howManyTicketsLeftMapped={howManyTicketsLeftMapped}/>);
    }

    return <List gap="20px">
        { tickets?.map((ticket, index) => <Ticket error={getTicketError(index, ticket?.id)} key={index} index={index} ticket={ticket} onTicketQuantityChange={onTicketQuantityChange}/>) }

        <ButtonModify onClick={showAttendees}>Attendee Information</ButtonModify>
    </List>
}

class EventNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            params: {
                tickets: [],
                attendees: [],
                discount: 0,
                booker_type: 'App\\Models\\User',
                booker_id: window.user.id,
                payment_type: 'bacs',
            },
            errors: {},
            agree: false,
            quote: null,
            event: null,
        }
    }

    componentDidMount() {
        this.getEvent();
    }

    getQueryParamsTicket(id) {
        const searchParams = new URLSearchParams(window.location.search);

        const tickets = queryString.parse(searchParams.get('tickets'));

        return tickets?.[id];
    }

    getEvent() {
        eventsApi.getEvent(this.props.id).then(({ data }) => {
            this.setState({ event: data }, () => {
                this.setupTickets();
            });
        })
    }

    book() {
        let params = { ...this.state.params };

        params.tickets = params.tickets.filter(ticket => ticket.quantity > 0);

        eventsApi.bookEvent(this.props.id, params, (errors) => {
            this.checkErrors(errors);
        }).then(({ data }) => {
            window.location.href = `/mydmc/events/${this.props.id}/bookings/${data.id}`;
        })
    }

    checkErrors(errors) {
        this.setState({ errors });

        if (errors?.booker_id !== undefined) {
            const details = document.querySelector('.billing-details');

            if (details) details.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }

    onChangeNameValue(name, value) {
        const params = { ...this.state.params }

        params[name] = value;

        this.setState({ params });
    }

    onChangeObject(obj, callback = () => {}) {
        const params = { 
            ...this.state.params,
            ...obj 
        }

        this.setState({ params }, callback)
    }

    setupTickets() {
        let tickets = [ ...this.state.event.event_ticket_types ];

        tickets = tickets?.map((ticket) => {
            const queryParamsQuantity = this.getQueryParamsTicket(ticket.id) || 0;

            return {
                ...ticket,
                event_ticket_type_id: ticket?.id,
                quantity: Number.parseInt(queryParamsQuantity) || 0,
            }
        });

        this.onChangeObject({ tickets }, () => {
            const searchParams = new URLSearchParams(window.location.search);

            if (searchParams.size > 0) this.getBookingCosts();
        });
    }

    onTicketQuantityChange(id, value) {
        const tickets =  [ ...this.state.params?.tickets ];
        const index = tickets.findIndex(e => e.event_ticket_type_id === id);

        tickets[index].quantity = value;

        this.onChangeObject({ tickets }, () => this.getBookingCosts());
    }

    getBookingCosts = _.debounce(() => {
        eventsApi.getBookingCosts(this.state.event.id, {
            tickets: this.state.params.tickets?.map(({ event_ticket_type_id, quantity }) => {
                return {
                    event_ticket_type_id,
                    quantity
                }
            }).filter(({ quantity }) => quantity > 0),
            discount: this.state.params?.discount,
        }).then(({ data }) => {
            let newData = { ...data };

            newData.tickets = newData.tickets.map((ticket) => {
                const eventTicket = this.state.params.tickets.find(({ event_ticket_type_id }) => event_ticket_type_id === ticket.event_ticket_type_id);

                return {
                    ...ticket,
                    ...eventTicket
                }
            })

            this.setState({ quote: newData }, () => {
                this.addCostsToTickets();
            })
        })
    }, 500, null);
    
    getQuoteTicket(id) {
        const ticket = this.state.quote?.tickets?.find(t => t.event_ticket_type_id === id);

        return {
            total: ticket?.total,
            errors: ticket?.errors,
        }
    }

    getTicketError(index, id) {
        let errors = Object.keys(this.state.errors)?.
            filter(key => key.startsWith(`tickets.${index}`)).
            map(key => {
                return this.state.errors[key]
            });

        if (errors?.length === 0) {
            errors = this.state?.quote?.tickets?.find(err => err?.event_ticket_type_id === id)?.errors || [];
        }

        return errors;
    }

    addCostsToTickets() {
        let tickets = [ ...this.state.params.tickets ];

        tickets = tickets.map((ticket) => {
            return {
                ...ticket,
                price: this.getQuoteTicket(ticket?.id)?.total
            }
        })

        this.onChangeObject({ tickets });
    }

    onAttendeeAdd(attendee) {
        const attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        let data = { ...attendee }

        delete data.meeting_attendee_id;
        delete data.meeting_attendee_type;
        delete data.personSelected;

        const type = attendee?.personSelected !== null ? 'App\\Models\\User' : 'App\\Models\\Contact';

        const ticket = this.state.params?.tickets?.find(t => t.event_ticket_type_id === attendee.event_ticket_type_id);

        if (attendee.hasOwnProperty('attendee_details')) {
            attendees.push({
                event_ticket_type: {
                    id: ticket?.id,
                    name: ticket?.name || 'Not Selected',
                },
                ...data,
            });
        } else {
            delete data.attendee_details;

            attendees.push({
                attendee_type: type,
                attendee_id: attendee?.personSelected?.id,
                attendee: {
                    ...attendee?.personSelected,
                    name: attendee?.personSelected?.name || `${attendee?.personSelected?.first_name} ${attendee?.personSelected?.last_name}`,
                },
                event_ticket_type: {
                    id: ticket?.id,
                    name: ticket?.name || 'Not Selected',
                },
                event_ticket_type_id: attendee?.event_ticket_type_id || null,
                ...data,
            })
        }

        this.onChangeObject({ attendees });
    }

    onAttendeeDelete(attendeeIndex) {
        let attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        attendees = attendees.filter((_, index) => index !== attendeeIndex);

        this.onChangeObject({ attendees });
    }

    onAttendeeUpdate(index, attendee) {
        const attendees = this.state.params?.attendees !== undefined ? [ ...this.state.params.attendees ] : [];

        let foundAttendee = attendees?.[index];

        const ticket = this.state.params?.tickets?.find(t => t.event_ticket_type_id === attendee.event_ticket_type_id);

        if (foundAttendee) {
            attendees[index] = {
                ...attendee,
                event_ticket_type: {
                    name: ticket?.name || 'Not Selected',
                }
            }
        }

        this.onChangeObject({ attendees });
    }

    howManyTicketsLeft() {
        const tickets = this.state.params?.tickets;

        const attendeesAssignedTickets = this.state.params?.attendees?.
            filter(attendee => attendee.event_ticket_type_id !== undefined && attendee.event_ticket_type_id !== null) || [];

        const ticketUsageCount = tickets.reduce((count, ticket) => {
            const selectedTicketId = ticket.id;
            const quantity = ticket.quantity;
        
            count[selectedTicketId] = quantity;
            
            attendeesAssignedTickets.forEach(attendee => {
                if (attendee.event_ticket_type_id === selectedTicketId) {
                    count[selectedTicketId]--;
                }
            });
            
            return count;
        }, {});

        return ticketUsageCount;
    }

    howManyTicketsLeftMapped() {
        const ticketsLeft = this.howManyTicketsLeft();
        const tickets = this.state.params?.tickets;

        return tickets.map(ticket => {
            return {        
                ...ticket,
                left: ticketsLeft?.[ticket?.id]
            }
        })
    }

    bookDisabled() {
        const tickets = this.state.params?.tickets;
        const hasNoTickets = tickets?.filter(ticket => ticket?.quantity > 0)?.length === 0;

        if (hasNoTickets) return true;
        if (this.state.agree === true) return false;

        return true;
    }

    render() {
        return (
            <Layout 
                theme="light"
                loading={this.state.event === null}
                topLeft={<Welcome title="Event Booking" subtitle={this.state.event?.name}/>}
                topRight={
                    <Row gap="20px">
                        <ButtonReturn responsive href="/mydmc/events">Cancel</ButtonReturn>
                    </Row>
                }
            >
            <MinMaxLayout
                main={
                    <div className="booking-view">
                        <List gap="40px" className="booking-view__child">
                            <Container>
                                <Container.Header>
                                    <Container.Text color="#FF6933" fontSize="18px">Confirm Details</Container.Text>
                                </Container.Header>

                                <Container.Content> 
                                    <List gap="40px">
                                        <div className="booking-view__image" role="img" aria-label="Event Cover Image" style={{ backgroundImage: `url('${MediaHelper.formatPublicPath(`/images/${this.state.event?.content?.feature_image?.[0]?.file_name}`)}')`}}></div>

                                        <LabelContainer label='Event Name'>
                                            { this.state.event?.name }
                                        </LabelContainer>

                                        <LabelContainer label="Booking Date & Duration">
                                            { getDSTLocalTime(this.state.event?.start).format('HH:mm A') } - { getDSTLocalTime(this.state.event?.start).add(this.state.event?.duration_mins, 'minutes').format('HH:mm A - DD/MM/YYYY') }
                                        </LabelContainer>

                                        <LabelContainer label={`Your Tickets (max. ${this.state.event?.max_tickets_per_booking} tickets per booking)`}>
                                            <Tickets
                                                getTicketError={this.getTicketError.bind(this)}
                                                howManyTicketsLeftMapped={this.howManyTicketsLeftMapped()}
                                                attendees={this.state.params?.attendees}
                                                onAttendeeAdd={this.onAttendeeAdd.bind(this)}
                                                onAttendeeDelete={this.onAttendeeDelete.bind(this)}
                                                onAttendeeUpdate={this.onAttendeeUpdate.bind(this)}
                                                tickets={this.state.params.tickets}
                                                onTicketQuantityChange={this.onTicketQuantityChange.bind(this)}
                                            />
                                        </LabelContainer>

                                        <LabelContainer label='Booking Location'>
                                            <Container.Text html={ this.state.event?.content?.location }/>
                                        </LabelContainer>
                                    </List>
                                </Container.Content>
                            </Container>

                            <ErrorContainer errors={this.state.errors?.booker_id !== undefined ? ['You have not setup a billing profile yet'] : null}>
                                <BillingDetails/>
                            </ErrorContainer>
                        </List>

                        <Container className="booking-view__child">
                            <Container.Header>
                                <Container.Text color="#FF6933" fontSize="18px">Summary</Container.Text>
                            </Container.Header>

                            <Container.Content>
                                <List gap="40px">
                                    <Summary
                                        quote={this.state.quote}
                                    />

                                    <div className="agree-box" style={{ padding: '0px', gap: '0px' }}>
                                        <div class="bac-bar">
                                            <p style={{ fontSize: '14px' }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                                                    <path id="Path_689" data-name="Path 689" d="M12,22A10,10,0,1,1,22,12,10,10,0,0,1,12,22ZM11,11v6h2V11Zm0-4V9h2V7Z" transform="translate(-2 -2)" fill="#fcfcfc"/>
                                                </svg>
                                                <b>Payment via BACS only</b> or using your <b>Membership Credits</b> (If Available)
                                            </p>
                                        </div>

                                        <div className="agree-box__inner">
                                            <InputsCheckbox
                                                text="I have read and agree to the booking terms and conditions"
                                                checked={this.state.agree}
                                                onChange={(e) => this.setState({ agree: e.value })}
                                            />
                                            <div className="agree-box__content">
                                                <div className="agree-box__details">
                                                    <div className="agree-box-details__detail">
                                                        <p>BACS Due</p>
                                                        <span>£{this.state.quote?.total || 0}</span>
                                                    </div>
                                                </div>

                                                <Blurred toggled={this.bookDisabled()}>
                                                    <ButtonModify onClick={this.book.bind(this)}>Complete your booking</ButtonModify>
                                                </Blurred>
                                            </div>
                                        </div>
                                    </div>


                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Booking Information</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={`${this.state.event?.booking_information}`}></Container.Text>
                                        </Container.Content>
                                    </Container>

                                    <Container>
                                        <Container.Header>
                                            <Container.Text fontSize="18px" color="#FF6933">Contact Us</Container.Text>
                                        </Container.Header>

                                        <Container.Content>
                                            <Container.Text fontSize="14px" color="#24191F" html={this.state.event?.content?.contact_details}/>
                                        </Container.Content>
                                    </Container>
                                </List>
                            </Container.Content>
                        </Container>
                    </div>
                }
            />
        </Layout>    
        )
    }
}

const el = document.getElementById('events-new');

if (el) {
    ReactDOM.render(<EventNew id={el.getAttribute('data-id')}/> , el);
}
